import NcInputNumber from "components/NcInputNumber";
import Prices from "components/Prices";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ModifierSetsContent from "./ModifierSetsContent";
import DescriptionContent from "./DescriptionContent";
import { useCartDataProvider } from "contaxt/CartProductContext";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import BagIcon from "components/BagIcon";
import NotifyCart from "./NotifyCart";

function ProductContent({
  itemData,
  modifierCheckedDatastate,
  qualitySelected,
  setQualitySelected,
  id,
  setItemData,
  requiredCheck,
  setShowError,
  checkedItem,
  showError,
  setModifierCheckedDatastate,
}: any) {
  console.log("itemData: ", itemData);
  const { dispatch } = useCartDataProvider();
  const navigate = useNavigate();
  const location = useLocation();

  const MERCHANT_STORAGE_KEY = "merchantname";
  const merchantname = Cookies.get(MERCHANT_STORAGE_KEY);

  const handleNoteChange = (event: any, index: any) => {
    const newNote = event.target.value;
    const updatedItems = [...itemData];
    updatedItems[index] = {
      ...updatedItems[index],
      note: newNote,
    };
    setItemData(updatedItems);

    if (location.state) {
      dispatch({
        type: "EDIT_CART",
        payload: {
          ...updatedItems[index],
          note: newNote,
          cartItemId: location.state.cartItemId,
        },
      });
    }
  };
  const NoteContent = () => {
    return (
      <>
        {itemData.map((item: any, index: number) => (
          <div key={index} className="w-full rounded-2xl space-y-2.5">
            <h3 className="flex items-center justify-between w-full px-4 py-2 font-medium text-left bg-slate-100/80 hover:bg-slate-200/60 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75 ">
              Add Note
            </h3>
            <textarea
              placeholder="Enter note"
              className="w-full h-20 px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-slate-500 focus:ring-opacity-75 dark:text-gray-100 dark:bg-gray-700"
              value={item.note || ""}
              onChange={(event) => handleNoteChange(event, index)}
            />
          </div>
        ))}
      </>
    );
  };
  return (
    <div className="space-y-7 2xl:space-y-8">
      {itemData.map((item: any) => (
        <div key={item.id}>
          <h2 className="text-2xl sm:text-3xl font-semibold">{item.name}</h2>
          <div className="flex items-center mt-5 space-x-4 sm:space-x-5">
            <Prices
              contentClass="py-1 px-2 md:py-1.5 md:px-3 text-lg font-semibold"
              // price={
              //   itemData[0].quantity
              //     ? item.price * itemData[0].quantity
              //     : item.price
              // }
              onlinePrice={item.onlinePrice}
              unit={item.unit?.name}
              priceType={item.priceType?.name}
            />
            {/* <div className="h-7 border-l border-slate-300 dark:border-slate-700"></div> */}
            <div className="flex items-center">
              {/* {item.isAvailable ? (
                    <span>Available</span>
                  ) : (
                    <span>Unavailable</span>
                  )} */}
              {/* <span className="hidden sm:block mx-2.5">·</span>
                  <div className="hidden sm:flex items-center text-sm">
                    <SparklesIcon className="w-3.5 h-3.5" />
                    <span className="ml-1 leading-none">{status}</span>
                  </div> */}
            </div>
          </div>
        </div>
      ))}
      {/* ---------- DESCRIPTION ----------  */}
      <div className="flex space-x-3.5">
        <div className="flex items-center justify-center bg-slate-100/70 dark:bg-slate-800/70 px-2 py-3 sm:p-3.5 rounded-full">
          <NcInputNumber
            defaultValue={qualitySelected}
            onChange={setQualitySelected}
            id={id}
            quantity={itemData[0].quantity}
            note={itemData[0].note}
            setItemData={setItemData}
            itemData={itemData}
          />
        </div>
      <ButtonPrimary
  className={`flex items-center justify-center gap-2 flex-1 flex-shrink-0 ${
    !itemData.some((item: any) => item.isAvailable)
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-black hover:bg-black"
  }`}
  onClick={() => {
    const allModifierSetsEmpty = itemData.every(
      (item: any) => item.modifierSets.length === 0
    );

    if (allModifierSetsEmpty) {
      if (location.state) {
        dispatch({
          type: "EDIT_CART",
          payload: {
            ...itemData[0],
            cartItemId: location.state.cartItemId,
          },
        });
      } else {
        dispatch({ type: "ADD_TO_CART", payload: itemData[0] });
      }
      NotifyCart(itemData);
    } else {
      if (requiredCheck) {
        if (location.state) {
          dispatch({
            type: "EDIT_CART",
            payload: {
              ...itemData[0],
              cartItemId: location.state.cartItemId,
            },
          });
        } else {
          dispatch({ type: "ADD_TO_CART", payload: itemData[0] });
        }
        NotifyCart(itemData);
        setShowError(false);
      } else {
        setShowError(true);
      }
    }

    if (requiredCheck) {
      navigate(`/${merchantname}`);
    }
  }}
  disabled={!itemData.some((item: any) => item.isAvailable)}
>
  <BagIcon className="w-5 h-5 hidden sm:inline-block" />
  {location.state ? (
    <span>Save Changes</span>
  ) : (
    <span>ADD TO CART</span>
  )}
</ButtonPrimary>

      </div>

      <hr className=" 2xl:!my-10 border-slate-200 dark:border-slate-700"></hr>

      <DescriptionContent itemData={itemData} />
      <ModifierSetsContent
        itemData={itemData}
        modifierCheckedDatastate={modifierCheckedDatastate}
        checkedItem={checkedItem}
        showError={showError}
        setModifierCheckedDatastate={setModifierCheckedDatastate}
      />

      {NoteContent()}
     <ButtonPrimary
  className={`flex items-center justify-center gap-2 flex-1 flex-shrink-0 ${
    !itemData.some((item: any) => item.isAvailable)
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-black hover:bg-black"
  }`}
  onClick={() => {
    const allModifierSetsEmpty = itemData.every(
      (item: any) => item.modifierSets.length === 0
    );

    if (allModifierSetsEmpty) {
      if (location.state) {
        dispatch({
          type: "EDIT_CART",
          payload: {
            ...itemData[0],
            cartItemId: location.state.cartItemId,
          },
        });
      } else {
        dispatch({ type: "ADD_TO_CART", payload: itemData[0] });
      }
      NotifyCart(itemData);
    } else {
      if (requiredCheck) {
        if (location.state) {
          dispatch({
            type: "EDIT_CART",
            payload: {
              ...itemData[0],
              cartItemId: location.state.cartItemId,
            },
          });
        } else {
          dispatch({ type: "ADD_TO_CART", payload: itemData[0] });
        }
        NotifyCart(itemData);
        setShowError(false);
      } else {
        setShowError(true);
      }
    }

    if (requiredCheck) {
      navigate(`/${merchantname}`);
    }
  }}
  disabled={!itemData.some((item: any) => item.isAvailable)}
>
  <BagIcon className="w-5 h-5 hidden sm:inline-block" />
  {location.state ? (
    <span>Save Changes</span>
  ) : (
    <span>ADD TO CART</span>
  )}
</ButtonPrimary>

      <div className="hidden xl:block">{/* <Policy /> */}</div>
    </div>
  );
}

export default ProductContent;
